import i18next from 'i18next';
import {type Record} from 'immutable';

import {type RootState} from 'web-app/react/redux/main-reducer';
import {type InferRecord} from 'web-app/util/immutable';

import EntityFactory from '../factory/famly-app';
import Session from '../sessions/model';

export type ISessionRecord = InferRecord<InstanceType<typeof Session['record']>>;

// Since the Session model is untyped we have to help TS with inferring the types a bit.
export default EntityFactory.createEntity<ISessionRecord, Record.Factory<ISessionRecord>, RootState>({
    domain: 'ENTITIES/SESSIONS',
    entityName: i18next.t('entities.names.session'),
    model: Session,
    apiDescription: {
        [EntityFactory.RequestType.FetchAll]: {
            url: 'v2/sessions',
            requestPayload: payload => ({
                institutionId: payload.institutionId,
                validOn: payload.validOn,
                validTo: payload.validTo,
                includeDiscontinued: payload.includeDiscontinued,
                ageGroupIds: payload.ageGroupIds,
                behaviors: 1,
            }),
            locateResponse: response => response.sessions,
        },
    },
});
